import MUIDataTable, {
  debounceSearchRender,
  MUIDataTableOptions,
  MUIDataTableProps,
  MUIDataTableState,
} from 'mui-datatables';
import React, { memo } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';

import { IRootState } from 'src/redux/rootReducer';
import { LoadingCommon, View } from 'src/components/common';
import './styles.scss';

const TableBasic: React.FC<Props> = ({
  isLoading,
  containerClassName,
  onTableChange,
  currentPage,
  options,
  total,
  filter,
  ...props
}) => {
  const tableOptions: MUIDataTableOptions = {
    serverSide: true,
    searchOpen: false,
    search: true,
    download: false,
    filter: typeof filter !== 'undefined' ? filter : true,
    print: false,
    viewColumns: false,
    selectableRowsHeader: false,
    selectableRows: 'none',
    textLabels: {
      body: {
        noMatch: isLoading ? <LoadingCommon /> : 'No data',
      },
    },
    jumpToPage: false,
    rowHover: true,
    onTableChange,
    customSearchRender: debounceSearchRender(500),
    ...options,
  };

  const hasRowClickAction = !!options?.onRowClick;
  const getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiPaper: {
          elevation4: {
            boxShadow: 'none',
          },
        },
        MuiTableRow: {
          hover: {
            cursor: hasRowClickAction ? 'pointer' : 'default',
          },
        },
        MuiTableBody: {
          root: {
            opacity: isLoading ? 0.3 : 1,
          },
        },
        MuiPopover: {
          paper: {
            minWidth: 300,
          },
        },
        MuiTableCell: {
          root: {
            padding: 12,
          },
        },
        MuiToolbar: {
          root: {
            marginTop: '16px',
          },
        },
      },
    });

  // More info: https://github.com/gregnb/mui-datatables
  return (
    <View className={cn('cmp-table-basic', containerClassName)}>
      <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable options={tableOptions} {...props} />
      </MuiThemeProvider>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  MUIDataTableProps & {
    containerClassName?: string;
    currentPage?: number;
    total?: number;
    onTableChange: (action: string, tableState: MUIDataTableState) => void;
    isLoading?: boolean;
    filter?: boolean;
  };

const mapStateToProps = (state: IRootState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(memo(TableBasic));
